// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spectrum--light .spectrum-Rule--large {\n  background-color: rgb(75, 75, 75);\n}\n.spectrum--light .spectrum-Rule--medium {\n  background-color: rgb(225, 225, 225);\n}\n.spectrum--light .spectrum-Rule--small {\n  background-color: rgb(225, 225, 225);\n}\n", ""]);
// Exports
module.exports = exports;
